import { OfferHttpService } from 'src/app/http/offer-http.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { LocationHttpService } from 'src/app/http/location-http.service';
import { Location } from '@angular/common';

@Component({
    selector: 'app-voucher-new',
    templateUrl: './voucher-new.component.html',
    styles: [],
})
export class VoucherNewComponent implements OnInit {
    constructor(
        private fb: FormBuilder,
        private offerHttpService: OfferHttpService,
        private router: Router,
        public location: Location,
        private activatedRoute: ActivatedRoute
    ) {}

    newVoucherForm = this.fb.group(
        {
            dicountValue: [null, Validators.required],
        },
        { updateOn: 'submit' }
    );

    formBusy: boolean;

    branches: any[] = [];

    ngOnInit(): void {
        this.routeData();
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.branches = data.data;
        });
    }

    onSubmit() {
        this.newVoucherForm.markAsTouched();
        if (this.newVoucherForm.valid) {
            this.formBusy = true;
            this.offerHttpService.addVoucherCode(this.newVoucherForm.value.dicountValue).subscribe((data) => {
                this.router.navigateByUrl('offer/voucher-list', {
                    state: { hasState: true, type: 'success', message: 'Voucher Created successfully' },
                });
            });
        }
    }
}
